import {Directive, ElementRef, Input, OnInit} from '@angular/core';
import {take} from 'rxjs';
import {SocialAuthService} from '@abacritt/angularx-social-login';

declare var google;

@Directive({
    selector: 'google-signin-butt'
})
export class GoogleSigninButtDirective implements OnInit {

    @Input('selectable') option: boolean;

    constructor(private el: ElementRef, private socialAuthService: SocialAuthService) {
    }

    ngOnInit() {
        if (!this.option) return;
        this.socialAuthService.initState.pipe(take(1)).subscribe(() => {
            google.accounts.id.renderButton(this.el.nativeElement, {
                type: 'standard',
                size: 'medium',
                text: 'signin_with',
                theme: 'filled_blue'
            });
        });
    }
}


